
<template>
   <div>
      <b-navbar type="dark" variant="dark">
         <b-navbar-nav>
            <b-nav-item href="#" @click="redirect2Main()">
               <i>BEIMING</i>
            </b-nav-item>

            <!-- Navbar dropdowns -->
            <b-nav-item-dropdown text="產品分類">
               <b-dropdown-item>
                  <router-link
                     class="nav-link dropdown"
                     :to="{
                        name: 'CustomerOrder',
                        path: '/customer_order',
                        params: { cat_name: item.name },
                        query: {
                           cat1_id: item.id,
                           cat1_name: item.name,
                           page_number: 1,
                        },
                     }"
                     v-for="item in cat1s"
                     :key="item.suuid"
                     ><font color="black">{{ item.name }}</font></router-link
                  >
               </b-dropdown-item>
            </b-nav-item-dropdown>
            <b-nav-item href="#" right @click="redirect2MemberProfile()">
               <font-awesome-icon :icon="['fas', 'user']" />
               {{ profile.exp }} 經驗值
            </b-nav-item>
         </b-navbar-nav>
      </b-navbar>
   </div>
</template>

<script>
export default {
   data() {
      return {
         productInfos: [],
         productInfo: {},
         cat1s: [],
         member: {},
         title: "",
         titleMaxLength: 12,
         profile:{},
      };
   },
   methods: {
      redirect2Main() {
         this.$router.push(`/customer/customer_order/`);
      },
      redirect2MemberProfile() {
         this.$router.push(`/customer/customer_profile/`);
      },
      getCat1s() {
         var vm = this;
         vm.isLoading = true;
         const apiUrl = `/mall/store/getAllCat1s?page_number=1`;
         vm.$ecServiceInstance
            .get(apiUrl)
            .then((response) => {
               //  console.log(response.data.data);
               this.cat1s = response.data.data;
               //  console.log("cat1s:", vm.cat1s);
            })
            .catch((error) => {
               console.error(error);
            });
      },
      async getMemberProfile() {
         return await this.$ecServiceInstance
            .post("/member/profile", {
               memberAuth: {
                  suuid: this.member.suuid,
                  accessToken: this.member.accessToken,
               },
            })
            .then((response) => {
              return response.data.data;
            })
            .catch((e) => {
               console.error(e);
            });
      },
   },
   watch: {
      title() {
         if (this.title.length > this.titleMaxLength) {
            this.title = String(this.title).slice(0, this.titleMaxLength);
         }
      },
   },
   async created() {
      this.getCat1s();

      this.member = JSON.parse(localStorage.getItem("member"));
      this.title = this.member.name;
      this.profile = await this.getMemberProfile();
      // console.log('this.profile:', this.profile);
      // console.log('this.member:', this.member);
      // this.member = this.$member;
      // console.log("this.member", this.member);
      // console.log('local storage:', JSON.parse(localStorage.getItem("member")));
      //this.user_suuid = localStorage.getItem("userSuuid");
   },
};
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue